var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardiac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 32",
    style: {
      enableBackground: "new 0 0 37 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#98DD78;fill-opacity:0.5;}\n\t.st1{clip-path:url(#SVGID_00000023258009383160558380000008312730654566501257_);}\n\t.st2{fill:none;stroke:#A977F9;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 30,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057130255070652655360000000817769164496588418_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057130255070652655360000000817769164496588418_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,14.7c0,0-6.1-1.6-7.3-7.2C2,6.8,3.5,6.1,3.5,6.1s1.8,3.9,5.1,5.6c0.7-0.9,2.3-6.4,7.8-7.8 c0.5,1.4,1.1,3.2,1.1,3.2s-5.9,1.5-4.7,7.8c0.3,1.9,0.8,3.7-0.4,6.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.3,8.8c0,0,1.3-3.5-0.3-7.1c1-0.3,2.5-0.7,2.5-0.7l0.4,1.8c0,0,0.2,0.8,0.8-0.1c0.6-1,1.1-1.6,1.1-1.6 s0.3-0.7,1.2-0.3l0.9,0.4c0,0,0.4,0.2,0.2,0.9c-0.3,0.7-0.6,3.1-0.2,4.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.2,12.8c0,0-3,6,1.6,11.5c1.7,1.8,6.7,5.8,10.8,4.9c0.8-0.3,3.4-0.5,4-7.2c0.1-0.8,1.2-10-6.6-12.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.5,21.7l6.3-12.3L29,21.7H16.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.8,13.8V18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.4,19.9h0.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiac);
export default __webpack_public_path__ + "static/media/Cardiac.90c7d68d4b90ea529b6fb8f89bb60b22.svg";
export { ForwardRef as ReactComponent };